module.exports = __webpack_public_path__ + "images/category_lp/brand/new/assessment_achievements/4_eb978c73485a866519b0bc100fb3a70b.png";